document.addEventListener("DOMContentLoaded", function () {

/* -----------------------
THUMB SCROLL
----------------------- */

const isMobile = window.innerWidth <= 768;
const thumbs = isMobile ? [] : document.querySelectorAll(".prestige-thumb");
const blocks = document.querySelectorAll(".prestige-image-block")

if(thumbs.length){

thumbs.forEach((thumb) => {

thumb.addEventListener("click", () => {

let index = thumb.dataset.index
let target = document.getElementById("prestige-image-" + index)

if(target){
target.scrollIntoView({
behavior: "smooth",
block: "start"
})
}

})

})

}

/* -----------------------
ACTIVE THUMB ON SCROLL
----------------------- */

if(blocks.length && !isMobile){

window.addEventListener("scroll", () => {

let scroll = window.scrollY + 200

blocks.forEach((block, i) => {

if (
scroll >= block.offsetTop &&
scroll < block.offsetTop + block.offsetHeight
) {

thumbs.forEach(t => t.classList.remove("active"))

if (thumbs[i]) {
thumbs[i].classList.add("active")
}

}

})

})

}

/* -----------------------
CUSTOM CURSOR
----------------------- */

const gallery = document.querySelector(".prestige-gallery")

const cursor = document.createElement("div")
cursor.classList.add("zoom-cursor")

document.body.appendChild(cursor)

document.addEventListener("mousemove", (e) => {

cursor.style.left = e.clientX + "px"
cursor.style.top = e.clientY + "px"

})

if (gallery) {

gallery.addEventListener("mouseenter", () => {
cursor.style.opacity = "1"
})

gallery.addEventListener("mouseleave", () => {
cursor.style.opacity = "0"
})

}

/* -----------------------
ZOOM MODAL
----------------------- */

const modal = document.getElementById("zoomModal")
const modalImg = document.getElementById("zoomImage")

const prev = document.querySelector(".zoom-prev")
const next = document.querySelector(".zoom-next")
const close = document.querySelector(".zoom-close")

const galleryImages = document.querySelectorAll(".prestige-gallery img")

let index = 0
let scale = 1
let startX = 0
let startY = 0
let panX = 0
let panY = 0
let isDragging = false

function resetZoom() {

scale = 1
panX = 0
panY = 0

updateTransform()

if(modalImg){
modalImg.style.cursor = "zoom-in"
}

}

if(galleryImages.length && modal && modalImg){

galleryImages.forEach((img, i) => {

img.addEventListener("click", () => {

modal.classList.add("active")
modalImg.src = img.src

index = i

resetZoom()

})

})

}

function closeModal() {

if(modal){
modal.classList.remove("active")
}

resetZoom()

}

if (close) close.addEventListener("click", closeModal)

document.addEventListener("keydown", (e) => {

if (e.key === "Escape") {
closeModal()
}

})

if (next && modalImg) {

next.addEventListener("click", () => {

index++

if (index >= galleryImages.length) {
index = 0
}

modalImg.src = galleryImages[index].src
resetZoom()

})

}

if (prev && modalImg) {

prev.addEventListener("click", () => {

index--

if (index < 0) {
index = galleryImages.length - 1
}

modalImg.src = galleryImages[index].src
resetZoom()

})

}

if(modalImg){

modalImg.addEventListener("wheel", (e) => {

e.preventDefault()

scale += e.deltaY * -0.0015
scale = Math.min(Math.max(1, scale), 4)

updateTransform()

})

modalImg.addEventListener("click", () => {

scale += 0.5

if (scale > 4) {
scale = 1
panX = 0
panY = 0
}

updateTransform()

})

modalImg.addEventListener("mousedown", (e) => {

if (scale <= 1) return

isDragging = true

startX = e.clientX - panX
startY = e.clientY - panY

modalImg.style.cursor = "grabbing"

})

}

document.addEventListener("mousemove", (e) => {

if (!isDragging) return

panX = e.clientX - startX
panY = e.clientY - startY

updateTransform()

})

document.addEventListener("mouseup", () => {

isDragging = false

if(modalImg){
if (scale > 1) {
modalImg.style.cursor = "grab"
} else {
modalImg.style.cursor = "zoom-in"
}
}

})

function updateTransform() {

if(modalImg){
modalImg.style.transform =
`translate(${panX}px, ${panY}px) scale(${scale})`
}

}

/* -----------------------
QUANTITY
----------------------- */

var plus = document.querySelector(".qty-plus")
var minus = document.querySelector(".qty-minus")
var input = document.querySelector(".qty-input")

if(plus && input){

plus.onclick = function(e){

e.preventDefault()

var max = parseInt(input.max) || 999
var val = parseInt(input.value) || 1

if(val < max){
input.value = val + 1
}

return false
}

}

if(minus && input){

minus.onclick = function(e){

e.preventDefault()

var val = parseInt(input.value) || 1

if(val > 1){
input.value = val - 1
}

return false
}

}


/* -----------------------
ACCORDION (SAFE TOGGLE FIX)
----------------------- */

document.querySelectorAll(".acc-title").forEach(title => {

title.addEventListener("click", () => {

const content = title.nextElementSibling
const icon = title.querySelector("span")

if(content){

if(content.style.display === "block"){

content.style.display = "none"
if(icon) icon.textContent = "+"

}else{

content.style.display = "block"
if(icon) icon.textContent = "−"

}

}

})

})

/* -----------------------
VARIANT SYSTEM
----------------------- */
const variants = window.productVariants || [];
const optionNames = window.productOptionNames || [];
const initialVariantId = window.initialVariantId;

let selectedOptions = {};

const sizeBtns = document.querySelectorAll(".variant-size-btn");
const colorRadios = document.querySelectorAll(".color-radio");

function refreshBucksCurrency() {
  if (window.bucksCC && typeof window.bucksCC.reConvert === "function") {
    window.bucksCC.reConvert();
  }
}

function getOptionValue(variant, optionName) {
  const index = optionNames.indexOf(optionName);
  if (index === -1) return null;
  return variant[`option${index + 1}`];
}

function getVariantFromSelections() {
  return variants.find((variant) => {
    const sizeValue = getOptionValue(variant, "size");
    const colorValue =
      getOptionValue(variant, "color") || getOptionValue(variant, "colour");

    if (selectedOptions.size && sizeValue != selectedOptions.size) return false;
    if (selectedOptions.color && colorValue != selectedOptions.color) return false;

    return true;
  });
}

function updateVariantImage(variant) {
  if (!variant || !variant.featured_media_id) return;

  document.querySelectorAll(".prestige-image-block").forEach((block) => {
    block.style.display = "none";
  });

  document.querySelectorAll(".prestige-mobile-slide").forEach((slide) => {
    slide.style.display = "none";
  });

  const targetBlock = document.querySelector(
    '.prestige-image-block[data-media-id="' + variant.featured_media_id + '"]'
  );

  const targetSlide = document.querySelector(
    '.prestige-mobile-slide[data-media-id="' + variant.featured_media_id + '"]'
  );

  if (targetBlock) {
    targetBlock.style.display = "block";
  }

  if (targetSlide) {
    targetSlide.style.display = "block";
  }
}

function syncVariantControls() {
  sizeBtns.forEach((btn) => {
    btn.classList.toggle("active", btn.dataset.value == selectedOptions.size);
  });

  colorRadios.forEach((radio) => {
    radio.checked = radio.value == selectedOptions.color;
  });
}

function updateVariant() {
  const variant = getVariantFromSelections();
  if (!variant) return;

  const skuBox = document.querySelector(".prestige-sku");
  if (skuBox) {
    skuBox.innerHTML = "SKU: " + (variant.sku || "");
  }

  const variantInput = document.getElementById("variant-id");
  if (variantInput) {
    variantInput.value = variant.id;
  }

  let stock = variant.inventory_quantity;
  if (stock === null || stock === undefined) stock = 999;

  if (input) {
    input.max = stock;
    if (parseInt(input.value) > stock) {
      input.value = stock > 0 ? stock : 1;
    }
  }

  const priceEl = document.getElementById("price-current");
  const compareEl = document.getElementById("price-compare");
  const discountEl = document.getElementById("price-discount");

  if (priceEl) {
  priceEl.innerHTML = variant.price_html || "";
}

if (variant.compare_at_price && variant.compare_at_price > variant.price) {
  if (compareEl) {
    compareEl.innerHTML = variant.compare_at_price_html || "";
    compareEl.style.display = "inline";
  }

  if (discountEl) {
    const discount = Math.round(
      ((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price
    );
    discountEl.innerText = discount + "% OFF";
    discountEl.style.display = "inline";
  }
} else {
  if (compareEl) {
    compareEl.innerHTML = "";
    compareEl.style.display = "none";
  }

  if (discountEl) {
    discountEl.innerText = "";
    discountEl.style.display = "none";
  }
}

refreshBucksCurrency();


  updateVariantImage(variant);
}

sizeBtns.forEach((btn) => {
  btn.addEventListener("click", () => {
    selectedOptions.size = btn.dataset.value;
    syncVariantControls();
    updateVariant();
  });
});

colorRadios.forEach((radio) => {
  radio.addEventListener("change", () => {
    selectedOptions.color = radio.value;
    syncVariantControls();
    updateVariant();
  });
});

const initialVariant =
  variants.find((v) => v.id == initialVariantId) ||
  variants[0];

if (initialVariant) {
  selectedOptions.size = getOptionValue(initialVariant, "size");
  selectedOptions.color =
    getOptionValue(initialVariant, "color") ||
    getOptionValue(initialVariant, "colour");

  syncVariantControls();
  updateVariant();
}



/* -----------------------
RECENTLY VIEWED
----------------------- */

let handle = window.location.pathname.split("/products/")[1];

let viewed = JSON.parse(localStorage.getItem("prestigeViewed")) || [];

viewed = viewed.filter(h => h !== handle);

viewed.unshift(handle);

viewed = viewed.slice(0, 20);

localStorage.setItem("prestigeViewed", JSON.stringify(viewed));

const rvGrid = document.querySelector(".prestige-recently-viewed .carousel-track");

if(rvGrid){

viewed.slice(1, 20).forEach(h => {

fetch(`/products/${h}.js`)
.then(r => r.json())
.then(p => {

let card = document.createElement("a");
card.href = p.url;
card.className = "prestige-product-card";

card.innerHTML = `
<img src="${p.images[0]}" />
<div class="card-title">${p.title}</div>
<div class="card-price">₹ ${(p.price/100).toLocaleString("en-IN")}</div>
`;

rvGrid.appendChild(card);

});

});

}


/* -----------------------
SIMILAR PRODUCTS
----------------------- */

const rec = document.querySelector(".product-recommendations");

if(rec){

fetch(rec.dataset.url)
.then(r => r.text())
.then(html => {
rec.innerHTML = html;
});

}

/* ===== CAROUSEL SYSTEM ===== */

function initPrestigeCarousel(carousel){

let track = carousel.querySelector(".carousel-track");
let next = carousel.querySelector(".next");
let prev = carousel.querySelector(".prev");

if(!track || track.dataset.init) return;

track.dataset.init = "true";

function getScroll(){
let card = track.querySelector(".prestige-product-card");
if(!card) return 320;
return card.offsetWidth + 28;
}

next?.addEventListener("click", () => {
track.scrollBy({ left: getScroll(), behavior: "smooth" });
});

prev?.addEventListener("click", () => {
track.scrollBy({ left: -getScroll(), behavior: "smooth" });
});

}

/* INIT EXISTING (recently viewed) */
document.querySelectorAll(".recommendations-carousel")
.forEach(initPrestigeCarousel);

/* WATCH FOR SHOPIFY AI RECOMMENDATIONS LOAD */
const observer = new MutationObserver(() => {
document.querySelectorAll(".recommendations-carousel")
.forEach(initPrestigeCarousel);
});

observer.observe(document.body, { childList:true, subtree:true });

})

/* dom ends */

/* SHARE BUTTON */

document.querySelector(".share-btn")?.addEventListener("click", function(){

if(navigator.share){

navigator.share({
title: document.title,
url: window.location.href
})

}else{

navigator.clipboard.writeText(window.location.href)
alert("Product link copied!")

}

})

/* -----------------------
BUY NOW
----------------------- */

const buyNowBtn = document.querySelector(".prestige-buy-now")

if(buyNowBtn){

buyNowBtn.addEventListener("click", function(){

let variantId = document.getElementById("variant-id").value
let qty = document.querySelector(".qty-input").value || 1

fetch('/cart/add.js', {
method: 'POST',
headers: {
'Content-Type': 'application/json'
},
body: JSON.stringify({
id: variantId,
quantity: qty
})
})
.then(() => {
window.location.href = "/checkout"
})

})

}

function updateVariantImage(variant) {
  if (!variant) return;

  const mediaId = String(variant.featured_media_id || "");
  const selectedColor = String(selectedOptions.color || "").trim().toLowerCase();

  const blocks = Array.from(document.querySelectorAll(".prestige-image-block"));
  const thumbs = Array.from(document.querySelectorAll(".prestige-thumb"));
  const slides = Array.from(document.querySelectorAll(".prestige-mobile-slide"));
  const dots = Array.from(document.querySelectorAll(".pm-dot"));

  const allItems = [...blocks, ...thumbs, ...slides];
  const hasAnyAltText = allItems.some((item) => {
    const alt = (item.dataset.alt || "").trim();
    return alt !== "";
  });

  const matchingBlocks = selectedColor
    ? blocks.filter((item) => (item.dataset.alt || "") === selectedColor)
    : [];

  const matchingThumbs = selectedColor
    ? thumbs.filter((item) => (item.dataset.alt || "") === selectedColor)
    : [];

  const matchingSlides = selectedColor
    ? slides.filter((item) => (item.dataset.alt || "") === selectedColor)
    : [];

  if (!hasAnyAltText) {
    blocks.forEach((block) => {
      block.style.display = "block";
    });

    thumbs.forEach((thumb) => {
      const isActive = thumb.dataset.mediaId === mediaId;
      thumb.style.display = "block";
      thumb.classList.toggle("active", isActive);
    });

    slides.forEach((slide) => {
      slide.style.display = "block";
    });

    dots.forEach((dot) => {
      dot.style.display = "inline-block";
      dot.classList.remove("active");
    });

    const activeSlide = slides.find((slide) => slide.dataset.mediaId === mediaId);
    if (activeSlide) {
      const activeIndex = activeSlide.dataset.index;
      const activeDot = document.querySelector('.pm-dot[data-index="' + activeIndex + '"]');
      if (activeDot) activeDot.classList.add("active");
    }

    return;
  }

  if (matchingBlocks.length || matchingThumbs.length || matchingSlides.length) {
    blocks.forEach((block) => {
      const matchesColor = (block.dataset.alt || "") === selectedColor;
      const isVariantImage = block.dataset.mediaId === mediaId;
      block.style.display = matchesColor || isVariantImage ? "block" : "none";
    });

    thumbs.forEach((thumb) => {
      const isVariantImage = thumb.dataset.mediaId === mediaId;
      thumb.style.display = isVariantImage ? "block" : "none";
      thumb.classList.toggle("active", isVariantImage);
    });

    slides.forEach((slide) => {
      const matchesColor = (slide.dataset.alt || "") === selectedColor;
      const isVariantImage = slide.dataset.mediaId === mediaId;
      slide.style.display = matchesColor || isVariantImage ? "block" : "none";
    });

    dots.forEach((dot) => {
      const slide = document.querySelector(
        '.prestige-mobile-slide[data-index="' + dot.dataset.index + '"]'
      );
      if (!slide) return;

      const isVisible = slide.style.display !== "none";
      const isActive = slide.dataset.mediaId === mediaId;

      dot.style.display = isVisible ? "inline-block" : "none";
      dot.classList.toggle("active", isActive);
    });

    return;
  }

  blocks.forEach((block) => {
    const isActive = block.dataset.mediaId === mediaId;
    block.style.display = isActive ? "block" : "none";
  });

  thumbs.forEach((thumb) => {
    const isActive = thumb.dataset.mediaId === mediaId;
    thumb.style.display = isActive ? "block" : "none";
    thumb.classList.toggle("active", isActive);
  });

  slides.forEach((slide) => {
    const isActive = slide.dataset.mediaId === mediaId;
    slide.style.display = isActive ? "block" : "none";
  });

  dots.forEach((dot) => {
    const slide = document.querySelector(
      '.prestige-mobile-slide[data-index="' + dot.dataset.index + '"]'
    );
    if (!slide) return;

    const isActive = slide.dataset.mediaId === mediaId;
    dot.style.display = isActive ? "inline-block" : "none";
    dot.classList.toggle("active", isActive);
  });
}




/* =========================
MOBILE CAROUSEL + ZOOM FIX
========================= */

document.addEventListener("DOMContentLoaded", function(){

const isMobile = window.innerWidth <= 768;

if(!isMobile) return;

const track = document.querySelector(".prestige-mobile-track");
const slides = document.querySelectorAll(".prestige-mobile-slide");
const dots = document.querySelectorAll(".pm-dot");
const next = document.querySelector(".pm-next");
const prev = document.querySelector(".pm-prev");

let current = 0;

/* SCROLL TO SLIDE */
function goToSlide(i){
  if(!track || !slides[i]) return;

  track.scrollTo({
    left: slides[i].offsetLeft,
    behavior: "smooth"
  });

  current = i;
  updateDots();
}

/* DOT UPDATE */
function updateDots(){
  dots.forEach(d => d.classList.remove("active"));
  if(dots[current]){
    dots[current].classList.add("active");
  }
}

/* DOT CLICK */
dots.forEach(dot=>{
  dot.addEventListener("click", ()=>{
    goToSlide(parseInt(dot.dataset.index));
  });
});

/* ARROWS */
next?.addEventListener("click", ()=>{
  let i = current + 1;
  if(i >= slides.length) i = 0;
  goToSlide(i);
});

prev?.addEventListener("click", ()=>{
  let i = current - 1;
  if(i < 0) i = slides.length - 1;
  goToSlide(i);
});

/* AUTO DETECT SLIDE ON SCROLL */
track?.addEventListener("scroll", ()=>{

  let scrollLeft = track.scrollLeft;

  slides.forEach((slide, i)=>{
    if(Math.abs(slide.offsetLeft - scrollLeft) < 50){
      current = i;
      updateDots();
    }
  });

});

/* INIT */
updateDots();

/* -----------------------
FIX ZOOM FOR MOBILE
----------------------- */

const modal = document.getElementById("zoomModal");
const modalImg = document.getElementById("zoomImage");

slides.forEach((slide, i)=>{

  let img = slide.querySelector("img");

  img.addEventListener("click", ()=>{

    if(!modal || !modalImg) return;

    modal.classList.add("active");
    modalImg.src = img.src;

    current = i;

  });

});

});